/**
 * @module actions/car
 */
import {
  SET_CAR_ACTIVE_STATE
} from '../constants'

/**
 * @description Set the active state of the car component
 * @return {Object} Redux action
 */
export function setCarActiveState (isActive) {
  return {
    type: SET_CAR_ACTIVE_STATE,
    isActive
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/car.js